export const CAFE_CONSTS = {
    GET_CAFES: "GET_CAFES",
    UPDATE_CAFE_BY_ID: "UPDATE_CAFE_BY_ID",
};